import React from "react"
import BillingView from "components/billings/BillingList"

const Billing = () => {
  return <BillingView />
}

export default Billing
